import {
  Box,
  List,
  ListItemText,
  Divider,
  Typography,
  ListItemAvatar,
  Avatar,
  ListItemButton,
  // Button,
} from "@mui/material"
import 
// React, 
{ useEffect } from "react"
import { Link } from "react-router-dom"
import { Helmet } from "react-helmet"

const PlanPage = () => {
  // const handleDownload = () => {
  //   const link = document.createElement("a")
  //   link.href = "/assets/V4_The_Ravinia_Pact.pdf"
  //   link.download = "V4_The_Ravinia_Pact.pdf"
  //   document.body.appendChild(link)
  //   link.click()
  //   document.body.removeChild(link)
  // }
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }, [])

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #1a1a1a, #2c5364)",
        color: "white",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: { xs: 6, md: 10 },
        px: 2,
      }}
    >
      <Helmet>
        <title>Plan Page</title>
      </Helmet>
      <Typography
        variant="h3"
        sx={{
          fontWeight: 700,
          color: "#00e676",
          textAlign: "center",
          letterSpacing: 1,
          mb: 2,
          textShadow: "0 2px 12px rgba(0,0,0,0.45)",
        }}
      >
        Highland Park Revenue Plans
      </Typography>
      <Divider sx={{ width: "60%", backgroundColor: "#00e676", mb: 3 }} />
      <Typography
        variant="h6"
        sx={{
          textAlign: "center",
          fontWeight: 500,
          color: "white",
          mb: 4,
          textShadow: "0 2px 8px rgba(0,0,0,0.25)",
          maxWidth: 700,
        }}
      >
        Comprehensive revenue plans providing objective solutions to enhance Highland Park's fiscal resilience.
      </Typography>
      <List
        sx={{
          width: { xs: "100%", sm: "80%", md: "50%" },
          bgcolor: "rgba(255,255,255,0.04)",
          border: "2px solid #00e676",
          borderRadius: "16px",
          boxShadow: "0 2px 12px rgba(0,0,0,0.18)",
        }}
      >
        <ListItemButton
          component={Link}
          to="/planA"
          sx={{
            textDecoration: "none",
            color: "inherit",
            "&:hover": { backgroundColor: "rgba(0, 230, 118, 0.08)" },
            "&:focus": { backgroundColor: "rgba(0, 230, 118, 0.12)" },
          }}
        >
          <ListItemAvatar>
            <Avatar alt="EREP Plan" sx={{ backgroundColor: "#84A586" }}>
              A
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={
              <Typography fontWeight={600} fontSize={"20px"}>
                The "Equitable Revenue Enhancement Plan"
              </Typography>
            }
            secondary={
              <Typography
                component="span"
                variant="body2"
                sx={{ color: "#fff", display: "inline", opacity: 0.85 }}
              >
                A Tiered Tax Structure for Large-Scale Entities in Southeast Highland Park
              </Typography>
            }
          />
        </ListItemButton>
        <Divider variant="inset" component="li" />
        <ListItemButton
          component={Link}
          to="/planB"
          sx={{
            textDecoration: "none",
            color: "inherit",
            "&:hover": { backgroundColor: "rgba(0, 230, 118, 0.08)" },
            "&:focus": { backgroundColor: "rgba(0, 230, 118, 0.12)" },
          }}
        >
          <ListItemAvatar>
            <Avatar alt="BEACON Plan" sx={{ backgroundColor: "#806201" }}>
              B
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={
              <Typography fontWeight={600} fontSize={"20px"}>
                The "BEACON" Plan
              </Typography>
            }
            secondary={
              <Typography
                component="span"
                variant="body2"
                sx={{ color: "#fff", display: "inline", opacity: 0.85 }}
              >
                Budget Enhancement And Community Optimization Network
              </Typography>
            }
          />
        </ListItemButton>
        <Divider variant="inset" component="li" />
        <ListItemButton
          component={Link}
          to="/planC"
          sx={{
            textDecoration: "none",
            color: "inherit",
            "&:hover": { backgroundColor: "rgba(0, 230, 118, 0.08)" },
            "&:focus": { backgroundColor: "rgba(0, 230, 118, 0.12)" },
          }}
        >
          <ListItemAvatar>
            <Avatar alt="RISE Plan" sx={{ backgroundColor: "#2f3fcc" }}>
              C
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={
              <Typography fontWeight={600} fontSize={"20px"}>
                The "RISE" Plan
              </Typography>
            }
            secondary={
              <Typography
                component="span"
                variant="body2"
                sx={{ color: "#fff", display: "inline", opacity: 0.85 }}
              >
                Revenue Initiatives for Sustainable Equity
              </Typography>
            }
          />
        </ListItemButton>
        <Divider variant="inset" component="li" />
        <ListItemButton
          component={Link}
          to="/planH"
          sx={{
            textDecoration: "none",
            color: "inherit",
            "&:hover": { backgroundColor: "rgba(0, 230, 118, 0.08)" },
            "&:focus": { backgroundColor: "rgba(0, 230, 118, 0.12)" },
          }}
        >
          <ListItemAvatar>
            <Avatar alt="RISE Plan" sx={{ backgroundColor: "#7532a8" }}>
              H
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={
              <Typography fontWeight={600} fontSize={"20px"}>
                NANCY SUCKS
              </Typography>
            }
            secondary={
              <Typography
                component="span"
                variant="body2"
                sx={{ color: "#fff", display: "inline", opacity: 0.85 }}
              >
                New Accountability and Necessary Change Yielding Sustainable Urban Community Key Solutions
              </Typography>
            }
          />
        </ListItemButton>
      </List>
      {/* <Button
        sx={{
          mt: 5,
          fontWeight: 900,
          fontSize: "1.15rem",
          borderRadius: "30px",
          px: 5,
          py: 2,
          backgroundColor: "#00e676",
          color: "#000",
          boxShadow: "0 2px 12px rgba(0,0,0,0.18)",
          "&:hover": { backgroundColor: "#00c853" },
        }}
        variant="contained"
        onClick={handleDownload}
      >
        Download The Ravinia Pact
      </Button> */}
    </Box>
  )
}

export default PlanPage
